import React from "react";
import { Link } from "gatsby";
import { Container } from "reactstrap";
import v4 from "uuid/v4";

const BreadcrumbRbx = ({ title, id, parent, hierarchy = [] }) => {
  function orderParents(p, ordered) {
    if (p === 0 || !hierarchy || !Array.isArray(hierarchy)) {
      return ordered;
    } else {
      const h = hierarchy.find((e) => e.post_id === p);
      if (h && h.post_title && h.post_link) {
        ordered.unshift({ title: h.post_title, link: h.post_link });
        return orderParents(h.post_parent, ordered);
      }
      return ordered;
    }
  }

  const parents = orderParents(parent, []);
  const hasParents = parents.length > 0;

  return (
    <div className="order-bottom py-2">
      <Container>
        <nav aria-label="Fil d'Ariane" role="navigation">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item d-none d-md-block">
              <Link to="/" className="text-dark" aria-label="Retour à l'accueil">
                Accueil
              </Link>
            </li>
            {hasParents && parents.map(({ link, title }, index) => (
              <li
                key={v4()}
                className={
                  index < parents.length - 1
                    ? "breadcrumb-item d-none d-md-block"
                    : "breadcrumb-item"
                }
              >
                <Link
                  to={link}
                  className="text-dark"
                  dangerouslySetInnerHTML={{ __html: title }}
                  aria-label={`Aller à ${title}`}
                />
              </li>
            ))}
            <li
              className="breadcrumb-item text-secondary d-none d-md-block"
              aria-current="page"
            >
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </li>
          </ol>
        </nav>
      </Container>
    </div>
  );
};

export default BreadcrumbRbx;
